export type ClassValue = string | false | null | undefined;

/** Junta classes condicionalmente sem puxar dependência externa. */
export function cx(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
